import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { CustomerFormViewProps } from "models/propTypes/customerPropTypes";
import { CustomerFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { CustomerFormSections } from "models/enums/customer";
//#endregion
//#region  components
import { useFormDirtyCheck, useWintForm, WintForm } from "components/common/wintForms";
import CreateOnChangeHandlers from "./sections/create/useChangeHandlers";
import CustomerAddressSection from "./sections/create/addressSection";
import GeneralDetailsSection from "./sections/create/generalSection";
import CustomerOtherDetailsSection from "./sections/create/otherDetailsSection";
import CustomerReferencePersonsSection from "./sections/create/referenceSection";
import RutRotSettingsSection from "./sections/create/rutRotSection";
import { CustomerConstants } from "utils/constants";
//#endregion

const GeneralSettingsForm: ForwardRefRenderFunction<FormHandles, CustomerFormViewProps> = (props, ref) => {
  const { selectedCustomerChangeHandler, organizationNumberChangeHandler, isCreate, canToggleActiveStatus, customer } =
    props;

  const { wintFormProps, connect, values, formState } = useWintForm<CustomerFormTypes.Create>({
    formRef: ref,
    defaultValues: props.defaultValues,
    validationSchema: props.getValidationSchema(CustomerFormSections.General),
    handleSubmit: props.handleSubmit,
  });

  React.useEffect(() => {
    props.setNavLayoutSections &&
      props.setNavLayoutSections([
        {
          key: CustomerConstants.SettingsNavKeys.General,
          label: TranslationKeys.Common.General,
        },
        {
          key: CustomerConstants.SettingsNavKeys.Address,
          label: TranslationKeys.Common.Address,
        },
        {
          key: CustomerConstants.SettingsNavKeys.Reference,
          label: TranslationKeys.Invoice.ReferencePersons,
        },
        {
          key: CustomerConstants.SettingsNavKeys.HouseWork,
          label: TranslationKeys.Invoice.RutRotDescription,
        },
        {
          key: CustomerConstants.SettingsNavKeys.Other,
          label: TranslationKeys.Common.OtherDetails,
        },
      ]);
  }, []);

  useFormDirtyCheck(props.defaultValues, values, props.onFormDirtyChange);

  return (
    <WintForm {...wintFormProps}>
      <CreateOnChangeHandlers
        values={values}
        connect={connect}
        selectedCustomerChangeHandler={selectedCustomerChangeHandler}
        organizationNumberChangeHandler={organizationNumberChangeHandler}
        isFormDirty={formState.dirty}
        onFormValidationChange={props.onFormValidationChange}
      />
      <GeneralDetailsSection connect={connect} isCreate={isCreate} canToggleActiveStatus={canToggleActiveStatus} />
      <CustomerAddressSection connect={connect} />
      <CustomerReferencePersonsSection connect={connect} customerId={customer?.id} isCreate={isCreate} />
      <RutRotSettingsSection connect={connect} />
      <CustomerOtherDetailsSection connect={connect} />
    </WintForm>
  );
};

export default forwardRef(GeneralSettingsForm);
